import React from 'react';
import { Link, useLocation, useNavigate, matchPath } from 'react-router-dom';
import { BarChart3, Calendar, DollarSign, Home, PieChart, RepeatIcon, Users, ArrowUpDown, CreditCard, UserCog, Calculator, TrendingDown } from 'lucide-react';
import { supabase } from '../lib/supabase';

const Navbar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const isActive = (path: string) => {
    return matchPath(path, location.pathname) ? 'bg-[#e67600]' : '';
  };

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate('/auth');
  };

  return (
    <nav className="bg-[#ff8200] text-white p-4">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center mb-4 md:mb-0">
          <DollarSign className="h-8 w-8 mr-2" />
          <h1 className="text-2xl font-bold">Financial Dashboard</h1>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link 
            to="/" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/')} ${isActive('/') ? 'bg-[#e67600]' : ''}`}
          >
            <Home className="h-5 w-5 mr-1" />
            <span>Home</span>
          </Link>
          <Link 
            to="/breakeven" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/breakeven')} ${isActive('/breakeven') ? 'bg-[#e67600]' : ''}`}
          >
            <BarChart3 className="h-5 w-5 mr-1" />
            <span>Breakeven</span>
          </Link>
          <Link 
            to="/expenses" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/expenses')} ${isActive('/expenses') ? 'bg-[#e67600]' : ''}`}
          >
            <PieChart className="h-5 w-5 mr-1" />
            <span>Expenses</span>
          </Link>
          <Link 
            to="/recurring" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/recurring')} ${isActive('/recurring') ? 'bg-[#e67600]' : ''}`}
          >
            <RepeatIcon className="h-5 w-5 mr-1" />
            <span>Recurring</span>
          </Link>
          <Link 
            to="/payroll" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/payroll')} ${isActive('/payroll') ? 'bg-[#e67600]' : ''}`}
          >
            <Users className="h-5 w-5 mr-1" />
            <span>Payroll</span>
          </Link>
          <Link 
            to="/transactions" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/transactions')} ${isActive('/transactions') ? 'bg-[#e67600]' : ''}`}
          >
            <ArrowUpDown className="h-5 w-5 mr-1" />
            <span>Transactions</span>
          </Link>
          <Link 
            to="/debts" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/debts')} ${isActive('/debts') ? 'bg-[#e67600]' : ''}`}
          >
            <CreditCard className="h-5 w-5 mr-1" />
            <span>Debts</span>
          </Link>
          <Link 
            to="/cashflow" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/cashflow')} ${isActive('/cashflow') ? 'bg-[#e67600]' : ''}`}
          >
            <Calendar className="h-5 w-5 mr-1" />
            <span>Cash Flow</span>
          </Link>
          <Link 
            to="/projection" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/projection')} ${isActive('/projection') ? 'bg-[#e67600]' : ''}`}
          >
            <Calculator className="h-5 w-5 mr-1" />
            <span>Location Projection</span>
          </Link>
          <Link 
            to="/debt-reduction" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/debt-reduction')} ${isActive('/debt-reduction') ? 'bg-[#e67600]' : ''}`}
          >
            <TrendingDown className="h-5 w-5 mr-1" />
            <span>Debt Reduction</span>
          </Link>
          <Link 
            to="/users" 
            className={`px-3 py-2 rounded hover:bg-[#e67600] flex items-center ${isActive('/users')} ${isActive('/users') ? 'bg-[#e67600]' : ''}`}
          >
            <UserCog className="h-5 w-5 mr-1" />
            <span>Users</span>
          </Link>
        </div>
        <button
          onClick={handleSignOut}
          className="px-3 py-2 rounded hover:bg-[#e67600] flex items-center mt-4 md:mt-0"
        >
          Sign Out
        </button>
      </div>
    </nav>
  );
};

export default Navbar;